<template>
  <LoginSnackbar :snackbar="SnackbarComponent" />
</template>

<script>
import LoginSnackbar from '@/components/Login/LoginSnackbar.vue'

export default {
  name: 'SnackbarComp',
  components: { LoginSnackbar },
  props: {
    SnackbarComponent: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
